"use client";

import { useState, useEffect } from "react";
import Image from "next/image";
import { siteData } from "@/lib/data";

export default function Clients() {
  const { clients } = siteData;
  const [newClients, setNewClients] = useState(clients.slice(0, 12));

  useEffect(() => {
    // Defer the update to avoid "setState synchronously within effect" warning
    // and ensuring we don't block the initial paint.
    const timer = setTimeout(() => {
      // Randomly select 12 clients to display
      const removeIndex = Math.floor(Math.random() * clients.length);
      setNewClients(clients.filter((_, idx) => idx !== removeIndex));
      // const shuffled = [...clients].sort(() => 0.5 - Math.random());
      // setNewClients(shuffled.slice(0, 12));
    }, 0);

    return () => clearTimeout(timer);
  }, [clients]);

  return (
    <section id="clients" className="py-20 bg-slate-50">
      <div className="container mx-auto px-4 md:px-6">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-extrabold text-(--secondary) mb-4">
            شركاء النجاح
          </h2>
          <p className="text-slate-500 text-lg max-w-2xl mx-auto">
            نفخر بثقة كبرى الشركات والمؤسسات التي تعاوننا معها
          </p>
        </div>

        <div className="grid grid-cols-4  justify-center items-center gap-4 md:mx-34 mt-[-24px] ">
          {newClients.map((client, idx) => (
            <div
              key={idx}
              className="group relative bg-white border border-slate-100 w-full h-20 md:w-65 md:h-35 rounded-xl md:rounded-2xl shadow-sm flex items-center justify-center p-2 md:p-6 hover:shadow-lg hover:border-[var(--primary)] transition-all duration-300 transform hover:-translate-y-1"
            >
              <div className="relative w-full h-full">
                <Image
                  src={client.logo}
                  alt={client.name}
                  fill
                  className="object-contain filter grayscale-0 opacity-100 md:grayscale md:opacity-70 group-hover:grayscale-0 group-hover:opacity-100 transition-all duration-300"
                />
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
